import React from 'react';
import { Users as UsersIcon, Crown, Zap, Shield } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const STAT_CONFIG = [
  { key: 'total', icon: UsersIcon, color: 'bg-blue-500/20', textColor: 'text-blue-400', label: 'Total Usuarios' },
  { key: 'vip', icon: Crown, color: 'bg-amber-500/20', textColor: 'text-amber-400', label: 'VIP' },
  { key: 'premium', icon: Zap, color: 'bg-purple-500/20', textColor: 'text-purple-400', label: 'Premium' },
  { key: 'admins', icon: Shield, color: 'bg-red-500/20', textColor: 'text-red-400', label: 'Admins' },
];

export const UserStatsCards = ({ users }) => {
  const stats = {
    total: users.length,
    vip: users.filter(u => u.subscription?.plan_id === 'vip').length,
    premium: users.filter(u => u.subscription?.plan_id === 'premium').length,
    admins: users.filter(u => u.is_admin).length,
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-testid="user-stats-cards">
      {STAT_CONFIG.map(({ key, icon: Icon, color, textColor, label }) => (
        <Card key={key} className="bg-gray-900 border-gray-800">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-xl ${color} flex items-center justify-center`}>
                <Icon size={20} className={textColor} />
              </div>
              <div>
                <p className="text-2xl font-bold text-white">{stats[key]}</p>
                <p className="text-gray-500 text-xs">{label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
